<template>
  <b-modal
    id="supervisor-photo-lightbox-modal"
    size="xl"
    centered
    hide-header
    :hide-footer="photos.length <= 1"
    body-class="p-1 text-center bg-dark"
    footer-class="justify-content-center"
    @hidden="$emit('hidden')"
  >
    <img
      v-if="photos.length"
      :src="photos[index]"
      style="max-width: 100%; max-height: 80vh; object-fit: contain"
    />
    <template #modal-footer>
      <b-button variant="light" @click="prev">&#8592; Prev</b-button>
      <span class="mx-3 text-white">{{ index + 1 }} / {{ photos.length }}</span>
      <b-button variant="light" @click="next">Next &#8594;</b-button>
    </template>
  </b-modal>
</template>

<script>
export default {
  name: 'SupervisorPhotoLightbox',

  props: {
    photos: { type: Array, default: () => [] },
    index: { type: Number, default: 0 },
  },

  methods: {
    prev() {
      const next = (this.index - 1 + this.photos.length) % this.photos.length
      this.$emit('update:index', next)
    },
    next() {
      const next = (this.index + 1) % this.photos.length
      this.$emit('update:index', next)
    },
  },
}
</script>
